export const BATCH_TASKS_ASSIGNEE_ID = "1543"; // Alexandre Daguet
export const KRONOS_EMPLOYEE_ID = "125"; // KRONOS
export const NOELLIE_EMPLOYEE_ID = "85";
